import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

const COMPONENT_ID = 'pricingTableCell'

export const PricingTableCellSchema = buildEntrySchemaFor(COMPONENT_ID, {
  fields: z.lazy(() =>
    z.object({
      availability: z.boolean(),
      customText: RichTextSchema.optional(),
    }),
  ),
})

export type PricingTableCell = z.infer<typeof PricingTableCellSchema>
